// extracted by mini-css-extract-plugin
export var currentSegment = "segmentIndicator-module--current-segment--c3fd2";
export var track = "segmentIndicator-module--track--0be58";